module.exports = __webpack_public_path__ + "media/images/emblems/Valeyres-sous-Ursins-coat_of_arms-c301210f560e1dff800ae127f1fd02dc.svg";